export default __webpack_public_path__ + "static/media/Foundingmembers.3b6e4ced.png";